<div class="container h-100">
    <div class="row h-100 justify-content-center align-items-center VerticalMargin">
        <div class="card SmallForm rounded col-12 col-lg-9">
            <div class="card-header MyCardHeader rounded-top">
                <div class="input-group">
                    <div class="form-control MyCardTitle">
                        <h2 class="Head">
                            Delete Account
                        </h2>
                    </div>
                </div>
            </div>
            <div class="card-body MyCardBody rounded-bottom">
                <div class="text-center" style="font-weight: 600">This action will do the following</div>
                <br />
                <ul>
                    <li>Permanently delete your account.</li>
                    <li>Permanently delete all your personal information and checkin details.</li>
                    <li>You will not be able to login anymore.</li>
                    <li>You can still use the app anonymously.</li>
                </ul>
                <br>
                <div class="text-center" style="font-weight: 600">Instructions to delete account</div>
                <br />
                <ul>
                    <li>Open your profile, click below.</li>
                    <br />
                    <div class="col-10">
                        <button class="btn btn-primary btn-block" [routerLink]="'/myprofile'" type="button">
                            <span> Open profile </span>
                        </button>
                    </div>
                    <br />
                    <li>If prompt, login to your account.</li>
                    <li>Click on UNSUBSCRIBE ACCOUNT.</li>
                    <li>Confirm the warning message.</li>
                    <li>Your account is deleted, and you will be logged out.</li>
                </ul>
            </div>
        </div>
    </div>
</div>